/* Cart reconciliation core. The mapping must be rendered by the authenticated
 * storefront for the current company location, never inferred from an email.
 * Not loaded by the live theme until catalog and fulfillment rollout complete.
 */
(function(root){
  'use strict';
  function plan(cart,map){
    const updates={},expected={},seen=new Set();
    const items=cart.items||[];
    for(const item of items){
      const id=String(item.variant_id),target=String(map[id]||id);
      if(!Number.isSafeInteger(item.quantity)||item.quantity<1)throw Error('Invalid cart quantity.');
      expected[target]=(expected[target]||0)+item.quantity;
      if(target!==id){
        if(item.selling_plan_allocation||Object.keys(item.properties||{}).length)throw Error('A customized material line needs review before conversion.');
        if(!/^\d+$/.test(target)||map[target])throw Error('Invalid resale variant mapping.');
        updates[item.key]=0;seen.add(target);
      }
    }
    for(const target of seen){
      const existing=items.filter(item=>String(item.variant_id)===target);
      if(existing.length>1||existing.some(item=>item.selling_plan_allocation||Object.keys(item.properties||{}).length))throw Error('A customized material line needs review before conversion.');
      updates[existing.length?existing[0].key:target]=expected[target];
    }
    return {updates,expected,changed:seen.size>0};
  }
  function verify(cart,expected){
    const actual={};
    for(const item of cart.items||[])actual[String(item.variant_id)]=(actual[String(item.variant_id)]||0)+item.quantity;
    const keys=Object.keys(expected).sort();
    return JSON.stringify(keys)===JSON.stringify(Object.keys(actual).sort())&&keys.every(id=>actual[id]===expected[id]);
  }
  // Keep one operation in flight. If the response is lost, re-read the actual
  // cart instead of replaying a relative increment that could duplicate items.
  function reconciler(api){
    let pending;
    return function(map){
      if(pending)return pending;
      pending=(async()=>{
        const before=await api.read(),p=plan(before,map);
        if(!p.changed)return before;
        try{await api.update(p.updates);}catch(error){
          const actual=await api.read();
          if(verify(actual,p.expected))return actual;
          throw Error('Cart update was not confirmed. Review your cart before continuing.');
        }
        const after=await api.read();
        if(!verify(after,p.expected))throw Error('Cart quantities changed during the update. Review your cart before continuing.');
        return after;
      })().finally(()=>{pending=null;});
      return pending;
    };
  }
  const api={plan,verify,reconciler};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else root.DeeDentalResaleCart=api;
})(typeof window!=='undefined'?window:globalThis);
